export const isWebCartFlow = () => {
    const isSessionStorageAvailable = typeof window !== "undefined" && typeof sessionStorage !== "undefined";

    return (
        isSessionStorageAvailable &&
        (sessionStorage.getItem("isFromWebCart") === "true" || sessionStorage.getItem("isFromGiftingCart") === "true")
    );
};
